import ApiService from './api.service';
import LanguageService from './language.service';
import {
  SolrNewsTypeName,
  SolrExhibitorTypeName,
  SolrProductTypeName,
  SolrFairTypeName,
  SolrFrameworkProgramTypeName,
  SolrSpeakerTypeName,
  SolrFrameworkProgramConfigurationTypeName,
  SideEventsAppKey
} from '@/common/Utility';
import { SOLR_URL } from './config';

/* eslint-disable no-unused-vars */
const SolrService = {
  getAutocompleteSuggetions(
    query,
    limitedFairEvents,
    fairGroups = [],
    types = [],
    categories = [],
    extraCategories = [],
    travelDestinations = [],
    halls = []
  ) {
    const cfq = this.getSuggestContext(
      limitedFairEvents,
      fairGroups,
      types,
      categories,
      extraCategories,
      travelDestinations,
      halls
    );
    let hallfq = '';
    if (halls.length) {
      hallfq = this.applyHallFq(halls.map(h => h.id));
    }
    const escapedQuery = encodeURIComponent(query);
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/suggest?`, `suggest.q=${escapedQuery}&suggest.cfq=${cfq}${hallfq}`);
  },
  getFrameworkProgramData(
    query = '*:*',
    offset = 0,
    rows = 25,
    sorting = 'asc',
    pickedDate,
    timeOfDayFilterValue,
    categoryFilterValue,
    spacesFilterValue,
    fpConfigurationFilter,
    showFavourites,
    favouriteItems,
    limitedFairEventsConfig,
  ) {
    const queryDate = this.getQueryDate(pickedDate, timeOfDayFilterValue, 'fp_starttime');
    const queryDateSp = queryDate.replaceAll('fp_starttime', 'fp_contribution_dates');

    /* empty config => all fairEvents */
    let limitedFairEvents;
    let encodedFairFq = null;
    try {
      limitedFairEvents = JSON.parse(limitedFairEventsConfig);
    } catch {
      limitedFairEvents = null;
    }
    if (limitedFairEvents) {
      const fairFq = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
      encodedFairFq = fairFq.replace(/&/g, '%26');
    }
    const fqFair = encodedFairFq ? `&fq=${encodedFairFq}` : '';

    let escapedQuery = encodeURIComponent(query);
    if (escapedQuery === '*%3A*') {
      escapedQuery = '*:*';
    }

    const categoryFilterValues = categoryFilterValue.map(f => `"${f.id}"`).join(' OR ');
    const spacesFilterValues = spacesFilterValue.map(f => `"${(f.id || '').slice(0, 90)}"`).join(' OR ');
    const topicFilterValues = this.mapFpConfigurationFilter(fpConfigurationFilter);

    let favouriteArray = [];
    let favouriteString = '';
    if (showFavourites) {
      favouriteArray = favouriteItems;
      for (let i = 0; i < favouriteArray.length; i += 1) {
        favouriteString = `(id:${favouriteArray.join(' OR id:')})`;
      }
      if (favouriteArray.length === 0) {
        favouriteString = 'nonExistent';
      }
    } else {
      favouriteString = '';
    }

    const favouriteFilterString = favouriteString ? ` ${favouriteString}` : '';
    const encodedFavouriteFilterString = favouriteFilterString.replace(/&/g, '%26');

    const fqFavourites = encodedFavouriteFilterString ? `&fq={!tag=favourites}(${encodedFavouriteFilterString})` : '';

    let filterQuery = [];
    if (topicFilterValues !== '') {
      filterQuery.push(`fp_topics:(${topicFilterValues})`);
    }
    if (categoryFilterValues !== '') {
      filterQuery.push(`av_categories:(${categoryFilterValues})`);
    }
    if (spacesFilterValues !== '') {
      filterQuery.push(`fp_space_filter:(${spacesFilterValues})`);
    }

    filterQuery = filterQuery.join(' AND ');
    filterQuery = filterQuery || '*:*';

    const excludeTags = 'query';
    const jsonFacet = {
      typeReduced: {
        type: 'terms',
        field: 'type',
        limit: -1,
        mincount: 0,
        domain: {
          filter: `${encodedFairFq} AND ${filterQuery} AND (${queryDate} OR ${queryDateSp})`,
          excludeTags
        }
      },
      topics: {
        type: 'terms',
        field: 'fp_topics',
        limit: -1,
        sort: {
          index: 'asc',
        },
      },
      categories: {
        type: 'terms',
        field: 'av_categories',
        limit: -1,
        sort: {
          index: 'asc',
        },
      },
      spaces: {
        type: 'terms',
        field: 'fp_space',
        limit: -1,
        mincount: 1,
        sort: 'index',
        domain: {
          filter: `${encodedFairFq}`,
          excludeTags
        }
      },
    };

    const fq = encodeURIComponent(`{!tag=query}type:${SolrFrameworkProgramTypeName} AND ${filterQuery} AND (${queryDate})`);
    const queryComplete = `fq=${fq}${fqFavourites}${fqFair}&start=${offset}&rows=${rows}&sort=fp_starttime ${sorting},titleExact ${sorting}&q=${escapedQuery}&json.facet=${encodeURIComponent(JSON.stringify(jsonFacet))}`;
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, queryComplete);
  },
  getSpeakerData(
    query = '*:*',
    offset = 0,
    rows = 25,
    sorting = 'asc',
    pickedDate,
    timeOfDayFilterValue,
    limitedFairEventsConfig,
    spacesFilterValue
  ) {
    let escapedQuery = encodeURIComponent(query);
    if (escapedQuery === '*%3A*') {
      escapedQuery = '*:*';
    }

    const spacesFilterValues = spacesFilterValue.map(f => `"${f.id}"`).join(' OR ');
    let filterQuery = [];
    if (spacesFilterValues !== '') {
      filterQuery.push(`fp_space_filter:(${spacesFilterValues})`);
    }
    filterQuery = filterQuery.join(' AND ');
    filterQuery = filterQuery || '*:*';

    const queryDate = this.getQueryDate(pickedDate, timeOfDayFilterValue, 'fp_contribution_dates');
    const queryDateFp = queryDate.replaceAll('fp_contribution_dates', 'fp_starttime');

    /* empty config => all fairEvents */
    const limitedFairEvents = JSON.parse(limitedFairEventsConfig);
    const fairFq = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
    const encodedFairFq = fairFq.replace(/&/g, '%26');
    const fqFair = encodedFairFq ? `&fq=${encodedFairFq}` : '';

    const excludeTags = 'query';
    const jsonFacet = {
      typeReduced: {
        type: 'terms',
        field: 'type',
        limit: -1,
        mincount: 0,
        domain: {
          filter: `${encodedFairFq} AND (${queryDate} OR ${queryDateFp}) AND ${filterQuery}`,
          excludeTags
        }
      },
      spaces: {
        type: 'terms',
        field: 'fp_space',
        limit: -1,
        mincount: 1,
        sort: 'index',
        domain: {
          filter: `${encodedFairFq}`,
          excludeTags
        }
      },
    };
    const jsonFacetString = JSON.stringify(jsonFacet);

    const queryComplete = `fq={!tag=query}type:${SolrSpeakerTypeName} AND (${queryDate}) AND ${filterQuery}${fqFair}&start=${offset}&rows=${rows}&sort=fp_fullname ${sorting}&q=${escapedQuery}&json.facet=${jsonFacetString}`;
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, queryComplete);
  },
  getSpeakerLectureData(id) {
    const queryComplete = `q=fp_persons:${id}`;
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, queryComplete);
  },
  async getFrameworkProgramConfigurations(fairEventUids) {
    const fairFq = `(fair_ids:${fairEventUids.join(' OR fair_ids:')})`;
    const encodedFairFq = fairFq.replace(/&/g, '%26');
    const fqFair = encodedFairFq || '';
    const queryComplete = `q=*:*&fq=type:${SolrFrameworkProgramConfigurationTypeName}&fq=appKey:${SideEventsAppKey}&fq=${fqFair}`;
    const response = await ApiService.get(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?${queryComplete}`);
    return response.data.response.docs.map((d) => {
      const parsed = {...d};
      parsed.fp_topics = parsed.fp_topics ? JSON.parse(parsed.fp_topics) : [];
      parsed.fp_persons = parsed.fp_persons ? JSON.parse(parsed.fp_persons) : [];
      return parsed;
    });
  },
  getNewsData(
    query = '*:*',
    offset = 0,
    rows = 25,
    sorting = 'asc',
    limitedFairEventsConfig,
    showFavourites,
    favouriteItems,
  ) {
    let escapedQuery = encodeURIComponent(query);
    if (escapedQuery === '*%3A*') {
      escapedQuery = '*:*';
    }

    /* empty config => all fairEvents */
    const limitedFairEvents = JSON.parse(limitedFairEventsConfig);
    const fairFq = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
    const encodedFairFq = fairFq.replace(/&/g, '%26');
    const fqFair = encodedFairFq ? `&fq=${encodedFairFq}` : '';


    let favouriteArray = [];
    let favouriteString = '';

    if (showFavourites) {
      favouriteArray = favouriteItems;
      for (let i = 0; i < favouriteArray.length; i += 1) {
        favouriteString = `(id:${favouriteArray.join(' OR id:')})`;
      }
      if (favouriteArray.length === 0) {
        favouriteString = 'nonExistent';
      }
    } else {
      favouriteString = '';
    }

    const favouriteFilterString = favouriteString ? ` ${favouriteString}` : '';
    const encodedFavouriteFilterString = favouriteFilterString.replace(/&/g, '%26');
    const fqFavourites = encodedFavouriteFilterString ? `&fq={!tag=favourites}(${encodedFavouriteFilterString})` : '';
    const excludeTags = 'query';

    const jsonFacet = {
      typeReduced: {
        type: 'terms',
        field: 'type',
        limit: -1,
        mincount: 0,
        domain: {
          filter: `${encodedFairFq} AND (type:${SolrNewsTypeName} OR type:${SolrExhibitorTypeName})`,
          excludeTags
        }
      },
    };
    const jsonFacetString = JSON.stringify(jsonFacet);

    const queryComplete = `fq={!tag=query}type:${SolrNewsTypeName}${fqFair}${fqFavourites}&start=${offset}&rows=${rows}&sort=date ${sorting}&q=${escapedQuery}&json.facet=${jsonFacetString}`;
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, queryComplete);
  },
  getProductData(
    query = '*:*',
    offset = 0,
    rows = 25,
    sorting = 'asc',
  ) {
    let escapedQuery = encodeURIComponent(query);
    if (escapedQuery === '*%3A*') {
      escapedQuery = '*:*';
    }
    const queryComplete = `fq=type:${SolrProductTypeName}&start=${offset}&rows=${rows}&sort=title ${sorting}&q=${escapedQuery}`;
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, queryComplete);
  },
  getAllData(
    query = '*:*',
    limitedFairEventsConfig,
    typeFilterValue,
    categoryFilterValue,
    extraCategoryFilterValue,
    showFavourites,
    favouriteItems,
    travelDestinationFilterValue,
    fairGroupsFilterValue,
    hallFilterValue,
    countryFilterValue,
    offset = 0,
    rows = 25,
    sorting = 'asc',
    getTopOfTheList = false,
  ) {
    const fqFromSuggestContext = this.getSuggestContext(
      limitedFairEventsConfig,
      fairGroupsFilterValue,
      typeFilterValue,
      categoryFilterValue,
      extraCategoryFilterValue,
      travelDestinationFilterValue,
    );

    const escapedQuery = encodeURIComponent(query);
    const fairGroupsArray = [];
    let favouriteArray = [];

    let limitedFairEventsString = '';
    let limitedFairEventsMultiValueFieldString;
    let favouriteString = '';
    let fairGroupsString = '';
    let fairGroupsStringMultiValue = '';

    /* build query for filter request, if there are filter already set */
    if (fairGroupsFilterValue !== null) {
      for (let i = 0; i < fairGroupsFilterValue.length; i += 1) {
        fairGroupsArray.push(fairGroupsFilterValue[i].id);
      }
      if (fairGroupsArray.length > 0) {
        fairGroupsString = `(fair_id:${fairGroupsArray.join(' OR fair_id:')})`;
        fairGroupsStringMultiValue = `(fair_ids:${fairGroupsArray.join(' OR fair_ids:')})`;
      }
    }

    const hallArray = [];
    let hallFq = '';
    if (hallFilterValue !== null) {
      for (let i = 0; i < hallFilterValue.length; i += 1) {
        hallArray.push(hallFilterValue[i].id);
      }
      hallFq = this.applyHallFq(hallArray);
    }

    const countryArray = [];
    let countryFq = '';
    if (countryFilterValue !== null) {
      for (let i = 0; i < countryFilterValue.length; i += 1) {
        countryArray.push(countryFilterValue[i].id);
      }
      countryFq = this.applyCountryFq(countryArray);
    }

    if (showFavourites) {
      favouriteArray = favouriteItems;
      for (let i = 0; i < favouriteArray.length; i += 1) {
        favouriteString = `(id:${favouriteArray.join(' OR id:')})`;
      }
      if (favouriteArray.length === 0) {
        favouriteString = 'nonExistent';
      }
    } else {
      favouriteString = '';
    }

    let fairFq = '';

    /* limit searched fairEvents by plugin configuration if there is no filter set */
    if (limitedFairEventsString === '') {
      /* empty config => all fairEvents */
      const limitedFairEvents = JSON.parse(limitedFairEventsConfig);
      if (limitedFairEvents.length > 0) {
        limitedFairEventsString = `(fair_id:${limitedFairEvents.join(' OR fair_id:')})`;
        fairFq = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
        limitedFairEventsMultiValueFieldString = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
      } else {
        limitedFairEventsString = '*:*';
        limitedFairEventsMultiValueFieldString = '*:*';
      }
    }

    // eslint-disable-next-line
    const favouriteFilterString = favouriteString ? ` ${favouriteString}` : '';

    /* encode & with %26 */
    const encodedFairFq = fairFq.replace(/&/g, '%26');
    const encodedFavouriteFilterString = favouriteFilterString.replace(/&/g, '%26');

    // eslint-disable-next-line
    const fl = 'fl=*,contacts:[json],av_booths:[json],av_jobs:[json],av_badges:[json],av_exhibitor_object:[json],av_teaser:[json],av_products:[json],av_news:[json],exhibitor_social_media:[json]';
    // const fqFair = encodedFairFilter ? `&fq=({!parent which=type:${SolrExhibitorTypeName} v="${encodedFairFilter}"}) ${typeString}` : '';
    const fqFair = encodedFairFq ? `&fq=${encodedFairFq}` : '';
    const fqFavourites = encodedFavouriteFilterString ? `&fq={!tag=favourites}(${encodedFavouriteFilterString})` : '';
    let fqTopOfTheList = '';

    if (getTopOfTheList) {
      fqTopOfTheList = '&fq=av_top_of_the_list:true';
    }

    // eslint-disable-next-line
    // const excludeTags = 'av_categories,favourites,query,type,av_travel_destinations,fair_groups,av_halls';
    const excludeTags = 'facet,query,favourites';
    const jsonFacet = {
      type: {
        type: 'terms',
        field: 'type',
        limit: -1,
        domain: {
          excludeTags,
        },
      },
      typeReduced: {
        type: 'terms',
        field: 'type',
        limit: -1,
        mincount: 0,
        domain: {
          filter: `((av_suggest_context:(${fqFromSuggestContext}) AND type:${SolrExhibitorTypeName}) OR type:${SolrNewsTypeName})${countryFq} AND ${encodedFavouriteFilterString || '*:*'}`,
          excludeTags
        }
      },
      travel_destination: {
        type: 'terms',
        field: 'av_travel_destinations',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          blockChildren: `type:${SolrExhibitorTypeName}`,
          filter: fairFq.replace(/\\"/g, '"'),
          excludeTags,
        },
      },
      hall: {
        type: 'terms',
        field: 'av_halls',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          filter: `${fairFq.replace(/\\"/g, '"')} AND -(av_halls:Undefiniert OR av_halls:Undefined) AND type:${SolrExhibitorTypeName}`,
          excludeTags,
        },
      },
      country: {
        type: 'terms',
        field: 'av_country',
        limit: -1,
        method: 'enum',
        sort: {
          index: 'asc',
        },
        domain: {
          excludeTags,
        },
      },
      fairEvent: {
        type: 'terms',
        field: 'fair_ids',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          excludeTags,
        },
      },
    };
    let isNews = false;
    let isProduct = false;
    let isExhibitor = false;
    let emptyTypeFilter = true;
    let ignoreFilter = false;
    let hideNewsAndProducts = false;
    if (typeFilterValue) {
      [].forEach.call(typeFilterValue, (filterType) => {
        if (filterType.id === SolrNewsTypeName) {
          isNews = true;
          emptyTypeFilter = false;
        } else if (filterType.id === SolrProductTypeName) {
          isProduct = true;
          emptyTypeFilter = false;
        } else if (filterType.id === SolrExhibitorTypeName) {
          isExhibitor = true;
          emptyTypeFilter = false;
        }
      });
    }
    if (query.includes(`id:${SolrExhibitorTypeName}`)) {
      ignoreFilter = true;
    }
    if ((categoryFilterValue && categoryFilterValue.length)
      || (extraCategoryFilterValue && extraCategoryFilterValue.length)
      || (travelDestinationFilterValue && travelDestinationFilterValue.length)
      || (hallFilterValue && hallFilterValue.length)) {
      hideNewsAndProducts = true;
    }

    const jsonFacetString = JSON.stringify(jsonFacet);
    let fqSuggest = '{!tag=facet}';
    fqSuggest += `((av_suggest_context:${fqFromSuggestContext} AND type:${SolrExhibitorTypeName}) OR type:${SolrNewsTypeName})`;

    const queryComplete = `${fl}&fq=${fqSuggest}${hallFq}${countryFq}${fqFavourites}&sort=av_sort ${sorting}&start=${offset}&rows=${rows}&q=${escapedQuery}&json.facet=${jsonFacetString}${fqTopOfTheList}${fqFair}&facet.range=`;
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, queryComplete);
  },
  getExhibitorData(
    query = '*:*',
    limitedFairEventsConfig,
    typeFilterValue,
    categoryFilterValue,
    extraCategoryFilterValue,
    showFavourites,
    favouriteItems,
    travelDestinationFilterValue,
    fairGroupsFilterValue,
    hallFilterValue,
    countryFilterValue,
    offset = 0,
    rows = 25,
    sorting = 'asc',
    getTopOfTheList = false,
    returnOnlyFilterQuery = false
  ) {
    const fqFromSuggestContext = this.getSuggestContext(
      limitedFairEventsConfig,
      fairGroupsFilterValue,
      typeFilterValue,
      categoryFilterValue,
      extraCategoryFilterValue,
      travelDestinationFilterValue,
    );

    const escapedQuery = encodeURIComponent(query);
    const fairGroupsArray = [];
    let favouriteArray = [];

    let limitedFairEventsString = '';
    let limitedFairEventsMultiValueFieldString;
    let favouriteString = '';
    let fairGroupsString = '';
    let fairGroupsStringMultiValue = '';

    /* build query for filter request, if there are filter already set */
    if (fairGroupsFilterValue !== null) {
      for (let i = 0; i < fairGroupsFilterValue.length; i += 1) {
        fairGroupsArray.push(fairGroupsFilterValue[i].id);
      }
      if (fairGroupsArray.length > 0) {
        fairGroupsString = `(fair_id:${fairGroupsArray.join(' OR fair_id:')})`;
        fairGroupsStringMultiValue = `(fair_ids:${fairGroupsArray.join(' OR fair_ids:')})`;
      }
    }

    const hallArray = [];
    let hallFq = '';
    if (hallFilterValue !== null) {
      for (let i = 0; i < hallFilterValue.length; i += 1) {
        hallArray.push(hallFilterValue[i].id);
      }
      hallFq = this.applyHallFq(hallArray);
    }

    const countryArray = [];
    let countryFq = '';
    if (countryFilterValue !== null) {
      for (let i = 0; i < countryFilterValue.length; i += 1) {
        countryArray.push(countryFilterValue[i].id);
      }
      countryFq = this.applyCountryFq(countryArray);
    }

    if (showFavourites) {
      favouriteArray = favouriteItems;
      for (let i = 0; i < favouriteArray.length; i += 1) {
        favouriteString = `(id:${favouriteArray.join(' OR id:')})`;
      }
      if (favouriteArray.length === 0) {
        favouriteString = 'nonExistent';
      }
    } else {
      favouriteString = '';
    }

    let fairFq = '';

    /* limit searched fairEvents by plugin configuration if there is no filter set */
    if (limitedFairEventsString === '') {
      /* empty config => all fairEvents */
      const limitedFairEvents = JSON.parse(limitedFairEventsConfig);
      if (limitedFairEvents.length > 0) {
        limitedFairEventsString = `(fair_id:${limitedFairEvents.join(' OR fair_id:')})`;
        fairFq = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
        limitedFairEventsMultiValueFieldString = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
      } else {
        limitedFairEventsString = '*:*';
        limitedFairEventsMultiValueFieldString = '*:*';
      }
    }

    // eslint-disable-next-line
    const favouriteFilterString = favouriteString ? ` ${favouriteString}` : '';

    /* encode & with %26 */
    const encodedFairFq = fairFq.replace(/&/g, '%26');
    const encodedFavouriteFilterString = favouriteFilterString.replace(/&/g, '%26');

    // eslint-disable-next-line
    const fl = 'fl=*,contacts:[json],av_booths:[json],av_jobs:[json],av_badges:[json],av_exhibitor_object:[json],av_teaser:[json],av_products:[json],av_news:[json],exhibitor_social_media:[json]';
    // const fqFair = encodedFairFilter ? `&fq=({!parent which=type:${SolrExhibitorTypeName} v="${encodedFairFilter}"}) ${typeString}` : '';
    const fqFair = encodedFairFq ? `&fq=${encodedFairFq}` : '';
    const fqFavourites = encodedFavouriteFilterString ? `&fq={!tag=favourites}(${encodedFavouriteFilterString})` : '';
    let fqTopOfTheList = '';

    if (getTopOfTheList) {
      fqTopOfTheList = '&fq=av_top_of_the_list:true';
    }

    // eslint-disable-next-line
    // const excludeTags = 'av_categories,favourites,query,type,av_travel_destinations,fair_groups,av_halls';
    const excludeTags = 'facet,query,favourites';
    const jsonFacet = {
      type: {
        type: 'terms',
        field: 'type',
        limit: -1,
        domain: {
          excludeTags,
        },
      },
      typeReduced: {
        type: 'terms',
        field: 'type',
        limit: -1,
        mincount: 0,
        domain: {
          filter: `((av_suggest_context:(${fqFromSuggestContext}) AND type:${SolrExhibitorTypeName}) OR type:${SolrNewsTypeName})${countryFq} AND ${encodedFavouriteFilterString || '*:*'}`,
          excludeTags
        }
      },
      travel_destination: {
        type: 'terms',
        field: 'av_travel_destinations',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          blockChildren: `type:${SolrExhibitorTypeName}`,
          filter: fairFq.replace(/\\"/g, '"').replaceAll('fair_ids', 'fair_id'),
          excludeTags,
        },
      },
      hall: {
        type: 'terms',
        field: 'av_halls',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          filter: `${fairFq.replace(/\\"/g, '"')} AND -(av_halls:Undefiniert OR av_halls:Undefined) AND type:${SolrExhibitorTypeName}`,
          excludeTags,
        },
      },
      country: {
        type: 'terms',
        field: 'av_country',
        limit: -1,
        method: 'enum',
        sort: {
          index: 'asc',
        },
        domain: {
          excludeTags,
        },
      },
      fairEvent: {
        type: 'terms',
        field: 'fair_ids',
        limit: -1,
        sort: {
          index: 'asc',
        },
        domain: {
          excludeTags,
        },
      },
    };
    // let isNews = false;
    let isProduct = false;
    let isExhibitor = false;
    let emptyTypeFilter = true;
    let ignoreFilter = false;
    // let hideNewsAndProducts = false;
    if (typeFilterValue) {
      [].forEach.call(typeFilterValue, (filterType) => {
        // if (filterType.id === SolrNewsTypeName) {
        //   isNews = true;
        //   emptyTypeFilter = false;
        // }
        if (filterType.id === SolrProductTypeName) {
          isProduct = true;
          emptyTypeFilter = false;
        } else if (filterType.id === SolrExhibitorTypeName) {
          isExhibitor = true;
          emptyTypeFilter = false;
        }
      });
    }
    if (query.includes(`id:${SolrExhibitorTypeName}`)) {
      ignoreFilter = true;
    }
    if ((categoryFilterValue && categoryFilterValue.length)
      || (extraCategoryFilterValue && extraCategoryFilterValue.length)
      || (travelDestinationFilterValue && travelDestinationFilterValue.length)
      || (hallFilterValue && hallFilterValue.length)) {
      // hideNewsAndProducts = true;
    }

    const jsonFacetString = JSON.stringify(jsonFacet);
    let fqSuggest = '{!tag=facet}';
    // if (isNews && !isExhibitor && !ignoreFilter) {
    //   fqSuggest += `type:${SolrNewsTypeName}`;
    // } else if (isProduct && !isExhibitor && !ignoreFilter) {
    //   if (isNews) {
    //     fqSuggest += ' OR ';
    //   }
    //   fqSuggest += `type:${SolrProductTypeName}`;
    // } else {
    //   fqSuggest += `((av_suggest_context:(${fqFromSuggestContext}) AND type:${SolrExhibitorTypeName})${(isNews || emptyTypeFilter || ignoreFilter) && !hideNewsAndProducts ? ` OR type:${SolrNewsTypeName}` : ''}${(isProduct || emptyTypeFilter || ignoreFilter) && !hideNewsAndProducts ? ` OR type:${SolrProductTypeName}` : ''})`;
    fqSuggest += `((av_suggest_context:(${fqFromSuggestContext}) AND type:${SolrExhibitorTypeName}))`;
    // }
    const queryComplete = `${fl}&fq=${fqSuggest}${hallFq}${countryFq}${fqFavourites}&sort=av_sort ${sorting}&start=${offset}&rows=${rows}&q=${escapedQuery}&json.facet=${jsonFacetString}${fqTopOfTheList}${fqFair}`;
    if (returnOnlyFilterQuery) {
      return `?fq=${fqSuggest}${hallFq}${countryFq}${fqFavourites}`;
    }

    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, queryComplete);
  },
  getCategories(fairUids) {
    if (fairUids.length === 0) {
      throw new Error('No FairUids were given');
    }

    const categoryQuery = `&fq=type:${SolrFairTypeName}&group=true&group.field=fair_id&q=*:*&fl=fair_id,av_categories_fair,av_categories_fair_extra`;
    let fairUidQuery = '';
    let index = 0;
    fairUids.forEach((fairUid) => {
      if (index === 0) {
        fairUidQuery = `fair_id:${fairUid}`;
      } else {
        fairUidQuery += ` OR fair_id:${fairUid}`;
      }
      index += 1;
    });
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, `${categoryQuery}&fq=${fairUidQuery}`);
  },
  getExhibitorForNews(id) {
    return ApiService.get(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?fl=title,av_logo&q=id:${id}&fq=appKey:mkdb3`);
  },
  /* gets the latest 3 news for selected fairEvents in plugin */
  // getLatestNews(limitedFairEventsConfig) {
  //   const newsType = `type:${SolrNewsTypeName}`;
  //   const sorting = 'date desc';
  //   const limit = 3;
  //   const limitedFairEvents = JSON.parse(limitedFairEventsConfig);
  //   const limitedFairEventsString = `(fair_ids:${limitedFairEvents.join(' OR fair_ids:')})`;
  //
  //   return ApiService.get(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?q=${newsType}&sort=${sorting}&rows=${limit}&fq=${limitedFairEventsString}`);
  // },
  getSuggestContext(
    limitedFairEvents,
    fairGroups = [],
    types = [],
    categories = [],
    extraCategories = [],
    travelDestinations = []
  ) {
    /* eslint-disable */
    fairGroups = fairGroups === null ? [] : fairGroups;
    types = types === null ? [] : types;
    categories = categories === null ? [] : categories;
    extraCategories = extraCategories === null ? [] : extraCategories;
    travelDestinations = travelDestinations === null ? [] : travelDestinations;
    /* eslint-enable */
    let cfq = '';
    const re = new RegExp(/[^a-zA-Z0-9_.]/g);
    // eslint-disable-next-line
    limitedFairEvents = JSON.parse(limitedFairEvents);
    if (fairGroups.length === 0) {
      // eslint-disable-next-line
      fairGroups = [];
      for (let l = 0; l < limitedFairEvents.length; l += 1) {
        fairGroups.push({ id: limitedFairEvents[l] });
      }
    }
    if (fairGroups.length) {
      for (let i = 0; i < fairGroups.length; i += 1) {
        if (i !== 0) {
          cfq += ' OR (';
        } else {
          cfq += '((';
        }
        cfq += `fairId__${fairGroups[i].id.toString().replace(re, '').toLowerCase()}`;
        if (categories && categories.length) {
          for (let j = 0; j < categories.length; j += 1) {
            if (j === 0) {
              cfq += ' AND (';
            } else {
              cfq += ' OR ';
            }
            const theId = categories[j].id.replace(/\|/g, '__');
            cfq += `category__${fairGroups[i].id.toString().replace(re, '').toLowerCase()}__${theId.replace(re, '').toLowerCase()}`;
          }
          cfq += ')';
        }

        if (extraCategories && extraCategories.length) {
          for (let j = 0; j < extraCategories.length; j += 1) {
            if (j === 0) {
              cfq += ' AND (';
            } else {
              cfq += ' OR ';
            }
            const theId = extraCategories[j].id.replace(/\|/g, '__');
            cfq += `extracategory__${fairGroups[i].id.toString().replace(re, '').toLowerCase()}__${theId.replace(re, '').toLowerCase()}`;
          }
          cfq += ')';
        }

        if (travelDestinations && travelDestinations.length) {
          for (let j = 0; j < travelDestinations.length; j += 1) {
            if (j === 0) {
              cfq += ' AND (';
            } else {
              cfq += ' OR ';
            }
            const theId = travelDestinations[j].id.replace(/\|/g, '__');
            cfq += `traveldestination__${fairGroups[i].id.toString().replace(re, '').toLowerCase()}__${theId.replace(re, '').toLowerCase()}`;
          }
          cfq += ')';
        }
        cfq += `) OR (always__${fairGroups[i].id.toString().replace(re, '').toLowerCase()})`;
      }
      cfq += ')';
    }
    return cfq;
  },
  applyHallFq(halls) {
    let fq = '';

    if (halls.length) {
      fq = ' AND ';
      const hallCombinations = halls.join('" OR "');
      fq += `av_halls:("${hallCombinations}") `;
    }

    return fq;
  },
  applyCountryFq(countries) {
    let fq = '';

    if (countries.length) {
      fq = ' AND ';
      const countryCombinations = countries.join('" OR "');
      fq += `av_country:("${countryCombinations}") `;
    }

    return fq;
  },
  getFairEvents(fairEvents) {
    const fairFq = `(fair_id:${fairEvents.join(' OR fair_id:')})`;
    return ApiService.post(`${SOLR_URL}/core_${LanguageService.getCurrentTYPO3Language()}/select?`, `q=*:*&fq=${fairFq}`);
  },
  getQueryDate(pickedDate, timeOfDayFilterValue, startTimeString) {
    let dateBegin = '';
    let dateEnd = '';
    let queryDate = '*:*';

    if (pickedDate.startDate) {
      const startDate = new Date(pickedDate.startDate);
      const endDate = new Date(pickedDate.endDate);
      startDate.setHours(3);
      endDate.setHours(3);
      dateBegin = startDate.toISOString();
      dateEnd = endDate.toISOString();
      const dayDifference = endDate.getDate() - startDate.getDate();
      const dateArray = [];

      const morningBegin = 'T00:00';
      const morningEnd = 'T11:59';
      const afternoonBegin = 'T12:00';
      const afternoonEnd = 'T23:59';

      if (timeOfDayFilterValue.id !== '') {
        let day = startDate.getDate();
        let dayString;
        let dateString;
        if (timeOfDayFilterValue.id === 'morning' || timeOfDayFilterValue.id === 'afternoon') {
          for (let i = 0; i <= dayDifference; i += 1) {
            if (day < 10) {
              dayString = `0${day}`;
            } else {
              dayString = day;
            }
            if (timeOfDayFilterValue.id === 'morning') {
              dateBegin = `${dateBegin.substring(0, 8)}${dayString}${morningBegin}${dateBegin.substring(16, 25)}`;
              dateEnd = `${dateBegin.substring(0, 8)}${dayString}${morningEnd}${dateBegin.substring(16, 25)}`;
            } else if (timeOfDayFilterValue.id === 'afternoon') {
              dateBegin = `${dateBegin.substring(0, 8)}${dayString}${afternoonBegin}${dateBegin.substring(16, 25)}`;
              dateEnd = `${dateBegin.substring(0, 8)}${dayString}${afternoonEnd}${dateBegin.substring(16, 25)}`;
            }
            dateString = `${startTimeString}:[${dateBegin} TO ${dateEnd}]`;
            dateArray.push(dateString);
            day += 1;
          }
          queryDate = dateArray.join(' OR ');
        } else {
          // set start time to 00:00:000
          dateBegin = `${dateBegin.substring(0, 11)}00${dateBegin.substring(13, 25)}`;

          // set end time to 23:59:000
          dateEnd = `${dateEnd.substring(0, 11)}23:59${dateEnd.substring(16, 25)}`;
          queryDate = `${startTimeString}:[${dateBegin} TO ${dateEnd}]`;
        }
      } else {
        dateBegin = `${dateBegin.substring(0, 11)}00${dateBegin.substring(13, 25)}`;
        dateEnd = `${dateEnd.substring(0, 11)}23:59${dateEnd.substring(16, 25)}`;
        queryDate = `${startTimeString}:[${dateBegin} TO ${dateEnd}]`;
      }
    }
    return queryDate;
  },
  mapFpConfigurationFilter(fpConfigFilter) {
    const filterArray = [];
    Object.values(fpConfigFilter).forEach((value) => {
      if (value.filterValue.length) {
        filterArray.push(value.filterValue.map(f => `"${f.id}"`).join(' OR '));
      }
    });
    return filterArray.join(' OR ');
  }
};

export default SolrService;
